import { ScreenStateType } from './types';

import { SET_WINDOW_SIZE, SetWindowSizeActionType } from './actions';

const initialState: ScreenStateType = {
  innerWidth: 0,
  innerHeight: 0,
};

export default function (state = initialState, action: SetWindowSizeActionType): ScreenStateType {
  if (action.type === SET_WINDOW_SIZE) {
    return { ...state, ...action.payload };
  }

  return state;
}
